<div class="relative grid h-28 grid-cols-12 rounded border border-aux-gray-dark py-3">
  <div class="col-span-7 flex flex-col justify-center rounded-l pl-5 pr-5" (click)="openList()">
    <div class="font-bold text-aux-black">{{ config.header }}</div>
    @if (config.options && config.options.length > 0) {
      <div class="flex items-center space-x-4" [ngClass]="{ invisible: loading }">
        <div class="text-sm">{{ selected }}</div>
        <div>
          <div
            class="-mt-1 h-2 w-2 rotate-45 transform border-b border-r border-aux-gray-dark-100"
          ></div>
        </div>
      </div>
    }
    @if (!loading && config.sub) {
      <div class="text-sm text-aux-gray-darkest" [innerHtml]="config.sub"></div>
    }
  </div>
  <div class="col-span-5 flex items-center justify-center space-x-2 rounded-r border-l">
    @if (config.showArrowUp) {
      <svg
        class="h-6 w-6 text-aux-error"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          d="M3.293 9.707a1 1 0 010-1.414l6-6a1 1 0 011.414 0l6 6a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L4.707 9.707a1 1 0 01-1.414 0z"
          clip-rule="evenodd"
        />
      </svg>
    }
    @if (!loading) {
      <div
        class="text-lg font-bold text-aux-gray-darkest"
        [innerHtml]="config.data[selectedIndex]"
      ></div>
    }
    @if (loading) {
      <div class="spinner"></div>
    }
  </div>

  <div class="absolute top-32">
    <div #trigger="cdkOverlayOrigin" cdkOverlayOrigin></div>
  </div>
</div>

<ng-template
  #overlay="cdkConnectedOverlay"
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isListOpen"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'ttt'"
  (detach)="closeList()"
  (backdropClick)="closeList()"
>
  <div
    class="w-full overflow-hidden rounded border border-aux-gray-dark bg-white text-sm text-aux-black shadow-lg"
  >
    <ul
      tabindex="-1"
      role="listbox"
      class="max-h-60 overflow-auto rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
      (keydown)="onListKeydown($event)"
    >
      @for (option of config.options; track option; let index = $index) {
        <li
          class="relative cursor-default select-none py-2 pl-3 pr-16 text-gray-900"
          id="listbox-option-{{ index }}"
          [ngClass]="{
            'bg-aux-gray-light': index === highlighted,
          }"
          (mouseenter)="highlightOption(index)"
          (mouseleave)="highlighted = null"
          (click)="selectOption()"
        >
          <span
            class="block truncate font-normal"
            [ngClass]="{
              'font-medium': index === selectedIndex,
            }"
          >
            {{ option }}
          </span>

          @if (index === selectedIndex) {
            <div class="absolute inset-y-0 right-0 flex items-center pr-2">
              <svg
                class="h-4 w-4"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          }
        </li>
      }
    </ul>
  </div>
</ng-template>
